export default "assets/images/icons/close-99128bc9.svg";